<template>

    <div class="container">

        <app-head title="Suppliers" />

        <div class="my-4">
            <h1>{{ __('Suppliers') }}</h1>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-6 g-4">

            <div class="col" v-for="supplier in suppliers">
                <div class="card h-100">
                    <div class="card-body">
                        <inertia-link :href="supplier.permalink" class="stretched-link">
                            <img class="img-fluid" :src="supplier.logo" :alt="supplier.name" v-if="supplier.logo" loading="lazy" style="max-height: 30px;" />
                            <h3 class="card-title h6" v-else>
                                {{ supplier.name }}
                            </h3>
                        </inertia-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Breadcrumbs from '@/shared/Breadcrumbs';

    export default {
        props: [
            'suppliers'
        ],
        data() {
            return {
            }
        },
        components: {
            Breadcrumbs,
        }
    }
</script>